<template>
  <div class="passengerInfoTable" v-if="Object.keys(passengerInfo).length>0">
    <table>
      <tr class="tableHead">
        <td colspan="6">港珠澳大橋過境香港國際機場旅客車票換領憑證<br/>Ticket redemption voucher</td>
      </tr>
      <tr class="tableTips">
        <td colspan="6">
          本人將於辦理出境後
          ，乘坐海天中轉大樓客車經港珠澳大橋前往海天中轉大樓離境。現提供乘坐客車及於香港轉機的航班資料<br/>
          Ideclared that l am departing to the skyPer Teminal for onwand fight via the Hong kong-Zhuhai-Macao
          Bridge with the shkyPier Teminal Transfer Coach. Forthe itinerary please refer below
        </td>
      </tr>
      <tr>
        <td>姓名/Name:</td>
        <td colspan="5">
          {{ passengerInfo.userName }}
        </td>
      </tr>
      <tr>
        <td>性別/Gender:</td>
        <td>{{ passengerInfo.gender }}</td>
        <td>出生日期/Birth:</td>
        <td>{{ passengerInfo.birthDate }}</td>
        <td>國籍/Nationality:</td>
        <td>{{ passengerInfo.nationality }}</td>
      </tr>
      <tr>
        <td>證件類型:<br/>Doucument Category:</td>
        <td colspan="5">{{ passengerInfo.documentType }}</td>
      </tr>
      <tr>
        <td>證件號碼:<br/>Doucument Number:</td>
        <td colspan="5">
          {{ passengerInfo.documentNo }}
        </td>
      </tr>
      <tr class="title">
        <td colspan="6">
          封關巴士資料
        </td>
      </tr>
      <tr>
        <td>巴士車牌:<br/>Bus License Plate:</td>
        <td></td>
        <td>座位號:<br/>Seat Number:</td>
        <td>{{ passengerInfo.seatNum }}</td>
        <td>客車發車時間:<br/>Bus Scheduled Departure Time:</td>
        <td>{{ passengerInfo.busDepartureTime }}</td>
      </tr>
      <tr class="title">
        <td colspan="6">
          離境航班資料
        </td>
      </tr>
      <tr>
        <td>航班編號:<br/>Flight No:</td>
        <td colspan="3">{{ passengerInfo.flightNo }}</td>
        <td colspan="2" rowspan="9" class="passengerSign">
          <span>乘客簽名:</span><br/>
          <span>Passenger Signature: </span><br/>
          <span>{{ passengerInfo.userName }}</span>

          <div class="stamp">
            <span>蓋章</span>
            <span>Inspection Stamp</span>
          </div>

        </td>
      </tr>
      <tr>
        <td>行李件數:<br/>Baggage Pieces:</td>
        <td colspan="3"></td>
      </tr>
      <tr>
        <td>航班預定起飛時間:<br/>Schedule Flight Departure Time:</td>
        <td colspan="3">{{ passengerInfo.flightDepartureDate }}</td>
      </tr>
      <tr>
        <td>中轉國家 城市:<br/>Transit City:</td>
        <td colspan="3">{{ passengerInfo.transitCity }}</td>
      </tr>
      <tr class="dashLine">
        <td>最終目的地:<br/>Final Destination:</td>
        <td colspan="3">{{ passengerInfo.finalDestination }}</td>
      </tr>
      <tr>
        <td>姓名:<br/>Name:</td>
        <td colspan="3">{{ passengerInfo.userName }}</td>
      </tr>
      <tr>
        <td>巴士車牌:<br/>Bus License Plate:</td>
        <td></td>
        <td>座位號:<br/>Seat Number:</td>
        <td>{{ passengerInfo.seatNum }}</td>
      </tr>
      <tr>
        <td>客車發車時間:<br/>Departure Time:</td>
        <td>{{ passengerInfo.busDepartureTime }}</td>
        <td>航班編號:<br/>Flight Number:</td>
        <td>{{ passengerInfo.flightNo }}</td>
      </tr>
      <tr>
        <td>起飛時間:<br/>Departure Time:</td>
        <td colspan="3">{{ passengerInfo.flightDepartureDate }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    passengerInfo: {
      type: Object,
      default: () => {
      }
    }
  },
}
</script>
<style lang="less" scoped>
.passengerInfoTable {
  table, td {
    border: 1px solid #9b9999;
    border-collapse: collapse;
    text-align: center;
  }

  .tableHead {
    font-size: 0.22rem;

    td {
      font-weight: bolder;
    }
  }

  .tableTips {
    font-size: .13rem;
  }

  td {
    padding: 0.2rem 0;
    width: 16%;
  }

  .passengerSign {
    .stamp {
      margin: 40px auto;
      border: 1px solid #888;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100px;
      height: 100px;
      border-radius: 50%;
    }
  }


  .label {
    width: 20%;
  }

  .dashLine {
    border-bottom: 1px dashed #9b9999 !important;

    td {
      border-bottom: none !important;
    }

    & + tr {
      td {
        border-top: none !important;
      }
    }
  }

  .title {
    background-color: #e2f0d9;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/airport_declaration_lists/components/passengerInfoTable.vue